__turbopack_context__.v({
  "icon": "ImagePlaceholder-module__IEAYqW__icon",
  "root": "ImagePlaceholder-module__IEAYqW__root",
});
